// extracted by css-extract-rspack-plugin
export default {"base":"VO2afk5ewDgMGZeF","tooltip":"kCLt2dg80VltVADS","slide":"soKbOMDT4VIGJwcW"};